const paths={
 folder:'<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10H3z"/>',
 department:'<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M9 21v-4h6v4M8 7h1m6 0h1M8 11h1m6 0h1"/>',
 group:'<circle cx="9" cy="8" r="3"/><path d="M2 21v-3a7 7 0 0 1 14 0v3M17 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 4 5v2"/>',
 user:'<circle cx="12" cy="8" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/>',
 plus:'<path d="M12 5v14M5 12h14"/>',
 edit:'<path d="m16 3 5 5-12 12-6 1 1-6zM14 5l5 5"/>',
 trash:'<path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7"/>',
 lock:'<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>',
 disk:'<rect x="3" y="5" width="18" height="14" rx="3"/><path d="M3 13h18M16 16h1"/>',
 refresh:'<path d="M20 7v5h-5M4 17v-5h5M5.5 7a7 7 0 0 1 12-2L20 8M4 16l2.5 3a7 7 0 0 0 12-2"/>',
 check:'<path d="m5 12 4 4L19 6"/>',
};
export function filesIcon(name:keyof typeof paths):string{
 return `<svg class="files-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${paths[name]}</svg>`;
}
export function escapeFiles(value:unknown):string{
 return String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]!));
}
export function filesAvatar(id:string,name:string):string{
 const initials=name.trim().split(/\s+/).slice(0,2).map(part=>[...part][0]??'').join('').toLocaleUpperCase('ru-RU');
 return `<span class="files-avatar" aria-hidden="true"><span>${escapeFiles(initials)||filesIcon('user')}</span><img data-files-avatar src="/api/files/accounts/${encodeURIComponent(id)}/avatar" alt="" loading="lazy" decoding="async" referrerpolicy="no-referrer"></span>`;
}
export function bindFilesAvatars(root:HTMLElement):void{
 root.querySelectorAll<HTMLImageElement>('[data-files-avatar]').forEach(img=>{
  img.addEventListener('error',()=>{img.hidden=true;},{once:true});
 });
}
export function russianCount(count:number,singular:string,few:string,many:string):string{
 const last=count%10,teen=count%100;return `${count} ${teen>=11&&teen<=14?many:last===1?singular:last>=2&&last<=4?few:many}`;
}
export function accessSummaryText(summary:{accounts:number;departments:number;chatGroups?:number}|undefined):string{
 if(!summary)return 'Назначения пока недоступны';
 return summary.accounts+summary.departments+(summary.chatGroups??0)===0?'Доступ закрыт для всех':`${russianCount(summary.departments,'отдел','отдела','отделов')}, ${russianCount(summary.accounts,'пользователь','пользователя','пользователей')}${summary.chatGroups?`, ${russianCount(summary.chatGroups,'группа чата','группы чата','групп чата')}`:''}`;
}
